import script from './RoadNet.vue2.mjs';

script.__file = "src/vue-amap/packages/layer/official/RoadNet/RoadNet.vue";

export { script as default };
//# sourceMappingURL=RoadNet.vue.mjs.map
